import { gql } from '@apollo/client';

export const DELETE_ADOPTION = gql`
  mutation deleteAdoption($id: ID!) {
    deleteAdoption(id: $id)
  }
`;
